import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { ExportExcelService } from 'src/app/services/export-excel.service';
import { OrderService } from 'src/app/services/order.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ESignService } from 'src/app/services/e-sign.service';
import { MessageService } from 'primeng/api';
import { StorageService } from 'src/app/services/storage.service';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { StoreOptionsService } from '../orders-listing/store-options.service';
import { PaymentService } from 'src/app/models/paymentService';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { LoginFlowConstants } from 'src/app/models/user-login.model';
import { UrlValidatorService } from 'src/app/services/url-validator.service';
import { DomainType } from 'src/app/enum/domain-type.enum';
import { map, Observable } from 'rxjs';
import { ORDER_DOCUMENT_CONSTANTS } from 'src/app/models/view-order.constant';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';

interface PaymentOption {
  name: string;
  code: string;
}
@Component({
    selector: 'app-view-order',
    templateUrl: './view-order.component.html',
    styleUrls: ['./view-order.component.scss'],
    standalone: false
})
export class ViewOrderComponent implements OnInit {
  @ViewChild('viewReviewOrder') viewReviewOrder: TemplateRef<any>;
  @ViewChild('paymentModal') paymentModal: TemplateRef<any>;
  @ViewChild('paymentPopup') paymentPopup: TemplateRef<any>;
  @ViewChild('viewBulkFilePdf') viewBulkFilePdf: TemplateRef<any>;
  @ViewChild('rejectReasonModal') rejectReasonModal: TemplateRef<any>;
  @ViewChild('paymentSummaryModal') paymentSummaryModal!: TemplateRef<any>;
  
  paymentAmountData: any;
  isLinkCopied: boolean[] = [false];
  paymentOption: PaymentOption[];
  selectedCity!: PaymentOption;
  signModeOptions: { label: string; value: string }[] = [
    { label: 'OTP', value: 'OTP' },
    { label: 'Fingerprint', value: 'Fingerprint' },
    { label: 'FaceRecognition', value: 'FaceRecognition' },
  ];
  orderId: number;
  orderDetail: any[] = [];
  order: any;
  esigns: any;
  additionalEsignDetails: any = [];
  estamps: any;
  isEstampExists: boolean;
  isEsignExists: boolean;
  orderDocument: any;
  audit: any;
  showDownloadDoc: boolean = false;
  pdfSource: any;
  viewAuditUrl: SafeResourceUrl;
  viewOrderDoucment: SafeResourceUrl;
  fileURL: string;
  selectedDate: any;
  selctedTime: any;
  submitted: boolean = false;
  bulkOrderId: any;
  selectedStampData: any;
  signerDetails: any;
  eSignDocument: any;
  esignData: any;
  onlyEsign: boolean = false;
  esign_id: string;
  signatory_id: string;
  queryParams = {
    signatory_id: '',
  };
  aduitSource: any;
  fileURLAudit: string;
  reviewMode: boolean = false;
  loggedEmail: any = 'admin@doqfy.in';
  reviewEmailData: any = [];
  reviewerDetails: { reviewer: string; approved: boolean; rejected: boolean } =
    { reviewer: 'admin@doqfy.in', approved: false, rejected: false };
  selectedSignerId: any;
  docName: string;
  minDate = new Date();
  showAuditButton: boolean = false;
  hasCompletedSignStatus: boolean = false;
  enableAuditTrial: boolean = false;
  @Input() viewOrderId: any;
  @Input() isBulkCatUploadOrder: boolean = false;
  paymentOrderData;
  noData: boolean = false;
  showCopyLink: boolean = false;
  paymentData: any;
  showSendLink = false;
  reOrderData: any;
  stampDetails: any;
  signDetails: any;
  currencySymbol: PaymentService;
  usedCurrency: any;
  /** Columns for the "Certificate Details" grid in the #viewCertificateModal.
   *  `referance_number` is spelt that way on the API payload, so the field key keeps the typo. */
  readonly certificateColumns: TableColumn[] = [
    { field: 'certificate_number', header: 'Certificate Number' },
    { field: 'referance_number', header: 'Reference Number' },
    { field: 'issued_date', header: 'Issued Date' },
    { field: 'denomination', header: 'Denomination' },
  ];

  /** Columns for the stamp bill grid in the payment summary. `s_no`, `price`, `quantity` and `amount`
   *  are rendered by *appTableCell templates in the markup (running index, currency prefix, literal 1),
   *  so they're declared here only to reserve the header and column position. */
  readonly stampBillColumns: TableColumn[] = [
    { field: 's_no', header: 'E-stamp' },
    { field: 'state_code', header: 'State Code' },
    { field: 'article_code', header: 'Article Code' },
    { field: 'stamp_duty', header: 'Stamp Duty' },
    { field: 'price', header: 'Price' },
    { field: 'quantity', header: 'Quantity' },
    { field: 'amount', header: 'Amount' },
  ];

  /** Columns for the e-sign bill grid. Every cell is supplied by an *appTableCell template. */
  readonly signBillColumns: TableColumn[] = [
    { field: 'serial', header: 'E-sign' },
    { field: 'method', header: 'Method' },
    { field: 'price', header: 'Price' },
    { field: 'quantity', header: 'Quantity' },
    { field: 'amount', header: 'Amount' },
  ];

  /** One row per sign method that actually has signers — see buildEsignBillRows(). */
  esignBillRows: any[] = [];

  electronicSigner: any[] = [];
  aadhaarSigner: any[] = [];
  dscSigner: any[] = [];
  dscSerialNo: number;
  electronicSerialNo: number;
  addharSerialNo: number;
  dscPrice: any;
  electronicPrice: any;
  aadhaarPrice: any;
  stampPrice: any;
  paymentLink: any;
  paymentStatus: ReturnType<typeof setInterval>;
  showPaymentOption: boolean;
  private popupWindow: Window | null = null;
  estampPlace: any;
  organisationId: any;
  showHdfcFields: boolean = false;
  showRefresh: boolean = false;
  isOperationalNeslOrder: boolean = false;
  neslActionLoading: 'status' | 'sync' | 'link' | 'retrigger' | null = null;
  neslStatusMessage: string = '';
  is_wallet: boolean = false;
  justCopied = false;
  failureReasonMap: { [key: string]: string } = {
    aadhaarNameMismatch: 'Party Name is mismtached with Aadhaar Name',
    // add more mappings as needed
  };
  isAbcl: boolean = false;
  isDocumentavailable: boolean = true;
  documentConstants: LoginFlowConstants = new LoginFlowConstants();
  bulkOrderData: any = null;
  userName: any;
  isLinkReady: boolean = false;
  rejectionReason: string = '';
rejectionSubmitted: boolean = false;

  constructor(
    private activatedRouter: ActivatedRoute,
    private modalService: NgbModal,
    public eSignService: ESignService,
    private messageService: MessageService,
    private storageService: StorageService,
    private orderService: OrderService,
    private sanitizer: DomSanitizer,
    private pathRoute: Router,
    private storeOptionsService: StoreOptionsService,
    private catUploadService: CatUploadService,
    private urlValidator: UrlValidatorService,
    private analytics: AnalyticsService,
    private featureFlagService: FeatureFlagService,
    private cdr: ChangeDetectorRef,
  ) {
    this.loggedEmail = this.storageService.getLoginEmail() || null;
    this.estampPlace = this.storageService.getPlace() || null;
    if (!this.estampPlace) {
      this.estampPlace = 'Bangalore';
    }
    this.showHdfcFields = this.featureFlagService.showHdhoFields();
    this.paymentOption = [
      { name: 'Pay Now', code: '1' },
      { name: 'Send Payment Link', code: '2' },
    ];
    this.selectedDate = new Date();
    this.currencySymbol = new PaymentService();
    this.usedCurrency = this.currencySymbol.currencies[10].symbol;
    this.is_wallet = this.storageService.getIsWallet();
  }

  ngOnInit(): void {
    this.isLinkCopied = [];
    this.orderDocument = '';
    this.isLinkReady = false;
    setTimeout(() => {
      this.isLinkReady = true;
    }, 1000);
    let organization_id = this.storageService.getOrganizationId() || null;
    if (this.is_wallet) {
      this.catUploadService
        .getPricingDetails(organization_id)
        .subscribe((res) => {
          this.electronicPrice = res.content.esign.electronic;
          this.dscPrice = res.content.esign.dsc;
          this.aadhaarPrice = res.content.esign.aadhaar;
          this.stampPrice = res.content.estamp;
          // Prices feed the e-sign bill rows; this call may resolve after the signers are grouped.
          this.buildEsignBillRows();
        });
    }

    if (this.isBulkCatUploadOrder === true) {
      this.orderService
        .getIndividualBulkCatUploadOrder(this.viewOrderId)
        .subscribe((res) => {
          const payload = res.data ?? res.content ?? [];
          if (Array.isArray(payload) && payload.length > 0) {
            this.bulkOrderData = payload[0];
            this.cdr.detectChanges();
          }
        });
    }

    this.userName = this.storageService.getLoginEmail();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.viewOrderId.currentValue) {
      const data = changes.viewOrderId.currentValue;
      const id = data.orderId;
      if (data.bulkOrderid) {
        this.bulkOrderId = data.bulkOrderid;
      }
      if (id) {
        this.orderId = id;
        if (this.orderId) {
          this.getOrderDetail();
        }
      }
    }
  }
  getValue(value) {
    if (value === '1') {
      this.payBillNow();
    } else {
      this.sendLinkToPayee(this.order?.id);
    }
  }

  sendContractReminderValues(esign) {
    if (!this.isLinkReady) {
      return;
    }
    this.selectedSignerId = esign.signatory_id;
    this.queryParams['order_id'] = this.orderId;
    this.queryParams['signatory_id'] = this.selectedSignerId;
    this.orderService.sendSignerReminder(this.queryParams).subscribe((res) => {
      this.messageService.add({
        severity: 'success',
        summary: res.message,
        icon: 'pi-check-circle',
      });
    });
  }

  onReinitiateEsign(esign) {
    const data = {
      esign_id: this.esign_id,
      signatory_id: esign.signatory_id,
    };
    this.eSignService.reinstateSign(data).subscribe((resp) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Re-initiated successfully',
        icon: 'pi-check-circle',
      });
      window.location.reload();
    });
  }

  auditDownload() {
    if (this.audit) {
      const link = document.createElement('a');
      link.href = this.fileURLAudit;
      link.download = this.order.referance_id + '_audit_trail.pdf';
      link.click();
    }
  }
  orderDownload() {
    if (this.showDownloadDoc) {
      const link = document.createElement('a');
      link.href = this.fileURL;

      // Replace spaces with underscores only if present
      const sanitizedId = this.order.referance_id.includes(' ')
        ? this.order.referance_id.replace(/ /g, '_')
        : this.order.referance_id;

      const filename = `${sanitizedId}.pdf`;
      link.download = filename;
      link.click();
    }
  }

  orderView(content) {
    if (this.showDownloadDoc) {
      this.modalService
        .open(content, {
          size: 'lg',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static',
          keyboard: false,
        })
        .result.then(
          (result) => {
            console.log(result);
          },
          (reason) => {
            console.log(reason);
          },
        );
    }
  }

  back() {
    this.modalService.dismissAll();
  }

  closeModel() {
    this.modalService.dismissAll();
  }

  getOrderDetail() {
    this.reviewMode = false;
    this.electronicSigner = [];
    this.aadhaarSigner = [];
    this.dscSigner = [];
    this.esignBillRows = [];
    this.orderService.getOrderDetail(this.orderId).subscribe((res: any) => {
      if (Object.keys(res['content']).length != 0) {
        this.noData = false;
        this.isAbcl = res['content'][0].abcl;
        this.orderDetail = res['content'];
        this.order = this.orderDetail[0].order;
        const isOperationalContract =
          String(
            this.orderDetail[0]?.additional_details?.general_fields
              ?.contract_type ?? '',
          ) === '002';
        this.isOperationalNeslOrder = false;
        this.enableAuditTrial = this.orderDetail[0].enable_audit_trail;
        if (
          this.order.status === 'IN_PROGRESS' ||
          this.order.status === 'COMPLETED'
        ) {
          this.showAuditButton = true;
        }
        this.showPaymentOption =
          this.order.user === this.storageService.getUserID() ? true : false;
        this.docName = this.order.referance_id;
        this.reviewEmailData = this.orderDetail[0].order_reviewers;
        this.paymentData = this.orderDetail[0].payment_data;
        if (this.order.status === 'WAITING_FOR_APPROVAL') {
          this.order.status_display = 'Approval Pending';
          this.reviewMode = this.reviewEmailData.find(
            (item) => item.reviewer === this.loggedEmail,
          );
          this.getReviewerData();
        } else if (this.paymentData.status === 'PAYMENT_PENDING') {
          this.getReviewerData();
        }
        this.estamps = this.orderDetail[0].estamp.map((estamp) => {
          const mergedAdditionalDetails =
            this.orderDetail[0].additional_details &&
            this.orderDetail[0].additional_details.estamps_details &&
            this.orderDetail[0].additional_details.estamps_details.reduce(
              (acc, detail) => {
                return { ...acc, ...detail };
              },
              {},
            );

          if (
            mergedAdditionalDetails &&
            Object.keys(mergedAdditionalDetails).length > 0
          ) {
            return {
              ...estamp,
              ...mergedAdditionalDetails,
            };
          }

          return estamp;
        });
        this.estamps.forEach((estamp) => {
          estamp.stamp_duty_paid_by === 'first_party_name'
            ? (estamp.stamp_duty_paid_by = estamp.first_party_name)
            : '';

          estamp.stamp_duty_paid_by === 'second_party_name'
            ? (estamp.stamp_duty_paid_by = estamp.second_party_name)
            : '';
        });
        this.orderService
          .getOrderDocument(this.orderId)
          .subscribe((ODres: any) => {
            if (
              ODres['content'].abcl === true &&
              ODres['message'] ===
                this.documentConstants.documentNotFoundMessage
            ) {
              this.isDocumentavailable = false;
            }
            if (ODres['content'].length > 1 && ODres['content'] != 'None') {
              const raw: string = ODres['content'];
              this.orderDocument = (raw.startsWith("b'") && raw.endsWith("'")) ? raw.slice(2, -1) : raw;
              try {
                const byteArray = new Uint8Array(
                  atob(this.orderDocument).split('').map((char) => char.charCodeAt(0))
                );
                const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
                this.fileURL = URL.createObjectURL(pdfBlob);
                this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileURL);
                this.showDownloadDoc = true;
              } catch (e) {
                console.error('Error processing document:', e);
                this.showDownloadDoc = false;
              }
              this.cdr.detectChanges();
            } else {
              this.showDownloadDoc = false;
            }
          });
        this.orderService
          .getAuditTrail(this.orderId)
          .subscribe((ATres: any) => {
            if (ATres['content'].length > 1) {
              this.audit = ATres['content'];
              const auditBlob = this.createSecurePdfBlob(this.audit);
              if (auditBlob) {
                this.fileURLAudit = URL.createObjectURL(auditBlob);
                this.aduitSource =
                  this.sanitizer.bypassSecurityTrustResourceUrl(
                    this.fileURLAudit,
                  );
              } else {
                console.error('Invalid audit trail document received');
              }
            } else {
              console.log(this.audit);
            }
          });
        if (this.estamps.length > 0) {
          this.isEstampExists = true;
        }
        this.esigns = this.orderDetail[0].esign;
        this.additionalEsignDetails =
          this.orderDetail[0].additional_details &&
          this.orderDetail[0].additional_details.esigns_details;
        this.esigns = this.orderDetail[0].esign.map((esign, index) => {
          const additionalDetails =
            (this.orderDetail[0].additional_details &&
              this.orderDetail[0].additional_details.esigns_details[index] &&
              this.orderDetail[0].additional_details.esigns_details[index]) ||
            {};
          if (additionalDetails && Object.keys(additionalDetails).length > 0) {
            return {
              ...esign,
              ...additionalDetails,
            };
          }
          return esign;
        });
        this.isOperationalNeslOrder =
          isOperationalContract &&
          this.esigns.some(
            (esign) =>
              String(esign?.provider || esign?.sign_provider || '')
                .trim()
                .toUpperCase() === 'NESL',
          );
        if (!this.isOperationalNeslOrder) {
          this.neslStatusMessage = '';
          this.neslActionLoading = null;
        }
        if (
          this.esigns[0]?.provider === 'DIGIO' &&
          this.order.status_display === 'In Progress'
        ) {
          this.showRefresh = true;
        } else {
          this.showRefresh = false;
        }
        if (this.esigns.length > 0) {
          this.isEsignExists = true;
          this.getEsignDetails();
        }
        this.stampDetails = this.paymentData?.stamp_bill ?? [];
        this.signDetails = this.paymentData?.esign_bill ?? [];
        this.signDetails.forEach((element) => {
          if (element.sign_method === 'ELECTRONIC') {
            this.electronicSigner.push(element);
          } else if (element.sign_method === 'AADHAAR') {
            this.aadhaarSigner.push(element);
          } else if (element.sign_method === 'DSC') {
            this.dscSigner.push(element);
          }
        });
        if (
          this.dscSigner.length != 0 &&
          this.electronicSigner.length != 0 &&
          this.aadhaarSigner.length != 0
        ) {
          this.dscSerialNo = 1;
          this.electronicSerialNo = 2;
          this.addharSerialNo = 3;
        } else if (
          this.electronicSigner.length != 0 &&
          this.aadhaarSigner.length != 0 &&
          this.dscSigner.length == 0
        ) {
          this.electronicSerialNo = 1;
          this.addharSerialNo = 2;
        } else if (
          this.aadhaarSigner.length != 0 &&
          this.dscSigner.length == 0 &&
          this.electronicSigner.length == 0
        ) {
          this.addharSerialNo = 1;
        } else if (
          this.aadhaarSigner.length == 0 &&
          this.dscSigner.length == 0 &&
          this.electronicSigner.length != 0
        ) {
          this.electronicSerialNo = 1;
        } else if (
          this.dscSigner.length != 0 &&
          this.electronicSigner.length == 0 &&
          this.aadhaarSigner.length != 0
        ) {
          this.dscSerialNo = 1;
          this.addharSerialNo = 2;
        } else if (
          this.dscSigner.length != 0 &&
          this.electronicSigner.length != 0 &&
          this.aadhaarSigner.length == 0
        ) {
          this.dscSerialNo = 1;
          this.electronicSerialNo = 2;
        }
        this.buildEsignBillRows();
      } else {
        this.noData = true;
      }
      this.cdr.detectChanges();
    });
  }

  // Add this helper method to your component
  private createSecurePdfBlob(base64Data: string): Blob | null {
    try {
      // Decode base64
      const byteArray = new Uint8Array(
        atob(base64Data)
          .split('')
          .map((char) => char.charCodeAt(0)),
      );

      // Validate PDF signature (PDFs start with %PDF-)
      const pdfSignature = String.fromCharCode(...byteArray.slice(0, 5));
      if (pdfSignature !== '%PDF-') {
        console.error('Invalid PDF signature detected');
        return null;
      }

      // Create blob with explicit PDF type
      const blob = new Blob([byteArray], {
        type: 'application/pdf',
      });

      return blob;
    } catch (error) {
      console.error('Error creating PDF blob:', error);
      return null;
    }
  }

  getReviewerData() {
    this.reviewEmailData.forEach((element) => {
      if (element.reviewer === this.loggedEmail) {
        this.reviewerDetails = element;
        this.showSendLink = true;
      }
    });
  }

  getPdfDocument(): Observable<string> {
    return this.orderService.getOrderDocument(this.orderId).pipe(
      map((ODres: any) => {
        if (
          ODres[ORDER_DOCUMENT_CONSTANTS.CONTENT][
            ORDER_DOCUMENT_CONSTANTS.ABCL
          ] === true &&
          ODres[ORDER_DOCUMENT_CONSTANTS.MESSAGE] ===
            this.documentConstants.documentNotFoundMessage
        ) {
          this.isDocumentavailable = false;
          return null;
        }

        if (
          ODres[ORDER_DOCUMENT_CONSTANTS.CONTENT].length > 1 &&
          ODres[ORDER_DOCUMENT_CONSTANTS.CONTENT] !==
            ORDER_DOCUMENT_CONSTANTS.NONE
        ) {
          let content: string = ODres[ORDER_DOCUMENT_CONSTANTS.CONTENT];
          if (typeof content === 'string' && content.startsWith("b'") && content.endsWith("'")) {
            content = content.slice(2, -1);
          }
          return content;
        } else {
          this.showDownloadDoc = false;
          this.messageService.add({
            severity: 'info',
            detail: ODres[ORDER_DOCUMENT_CONSTANTS.MESSAGE] || ORDER_DOCUMENT_CONSTANTS.DOCUMENT_NOT_GENERATED_WARNING,
          });
          return null;
        }
      }),
    );
  }
  viewPdfDocument() {
    this.getPdfDocument().subscribe((document: string) => {
      if (document) {
        this.orderDocument = document;
        try {
          const byteArray = new Uint8Array(
            atob(this.orderDocument)
              .split('')
              .map((char) => char.charCodeAt(0)),
          );
          const file = new Blob([byteArray], {
            type: ORDER_DOCUMENT_CONSTANTS.PDF_MIME_TYPE,
          });
          this.fileURL = URL.createObjectURL(file);
          this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileURL);
          this.showDownloadDoc = true;
          this.orderReView();
        } catch (e) {
          console.error('Error processing review document:', e);
        }
      }
    });
  }

  getEsignDetails() {
    this.eSignService.getEsignOrderDetails(this.orderId).subscribe((res) => {
      if (Object.keys(res[ORDER_DOCUMENT_CONSTANTS.CONTENT]).length != 0) {
        this.showCopyLink = true;
        this.isEsignExists = false;
        this.onlyEsign = true;

        this.esignData = res[ORDER_DOCUMENT_CONSTANTS.CONTENT];
        this.signerDetails = this.esignData.signatory_details;

        this.signerDetails = this.signerDetails.map((signer, index) => {
          const additionalDetails =
            Array.isArray(this.additionalEsignDetails) &&
            this.additionalEsignDetails[index]
              ? this.additionalEsignDetails[index]
              : {};

          const matchingEsign = this.esigns.find(
            (esign) =>
              esign.signatory_id === signer.signatory_id ||
              esign.email === signer.email,
          );

          let mergedSigner = { ...signer };

          if (Object.keys(additionalDetails).length > 0) {
            mergedSigner = { ...mergedSigner, ...additionalDetails };
          }

          if (matchingEsign && matchingEsign.cc_emails) {
            mergedSigner.cc_emails = matchingEsign.cc_emails;
          }

          return mergedSigner;
        });

        this.signerDetails.forEach((element) => {
          if (element.status === ORDER_DOCUMENT_CONSTANTS.STATUS_COMPLETED) {
            this.showAuditButton = true;
          }
        });

        this.eSignDocument = this.esignData.document;
        this.esign_id = this.esignData.esign_sequence.esign_id;
        this.signatory_id = this.esignData.signatory_details[0].signatory_id;
      } else {
        this.showCopyLink = false;
      }

      this.getPdfDocument().subscribe((document: string) => {
        if (document) {
          this.orderDocument = document;
          try {
            const byteArray = new Uint8Array(
              atob(this.orderDocument)
                .split('')
                .map((char) => char.charCodeAt(0)),
            );
            const file = new Blob([byteArray], {
              type: ORDER_DOCUMENT_CONSTANTS.PDF_MIME_TYPE,
            });
            this.fileURL = URL.createObjectURL(file);
            this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(this.fileURL);
            this.showDownloadDoc = true;
          } catch (e) {
            console.error('Error processing esign document:', e);
          }
        } else {
          this.showDownloadDoc = false;
        }
        this.cdr.detectChanges();
      });
    });
  }

  orderReView() {
    if (this.showDownloadDoc) {
      this.modalService
        .open(this.viewReviewOrder, {
          size: 'lg',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static',
          keyboard: false,
        })
        .result.then(
          (result) => {
            console.log(result);
          },
          (reason) => {
            console.log(reason);
          },
        );
    }
  }

  getLink(id: string, method: string, index: number) {
    if (!this.isLinkReady) {
      return;
    }
    this.signatory_id = id;
    if (method.toUpperCase() === 'AADHAAR' || method.toUpperCase() === 'DSC') {
      this.eSignService.getAadharLinkTab(
        this.esign_id,
        this.signatory_id,
        index,
      );
    } else if (method.toUpperCase() === 'ELECTRONIC') {
      this.eSignService.getEsignTab(this.esign_id, this.signatory_id, index);
    }
  }

  copyLink(url: string, index) {
    // Create a temporary input element
    const tempInput = document.createElement('input');
    tempInput.value = url;
    document.body.appendChild(tempInput);

    // Select the URL text
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); /* For mobile devices */

    // Copy the URL to clipboard
    document.execCommand('copy');

    this.isLinkCopied[index] = true;

    setTimeout(() => {
      this.isLinkCopied[index] = false; // Hide the message after a delay
    }, 1200);

    // Remove the temporary input element
    document.body.removeChild(tempInput);

    this.messageService.add({
      severity: 'success',
      detail: `Link Copied`,
    });
  }

  sendReminder(content, esign) {
    this.selectedSignerId = esign.signatory_id;
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        },
      );
  }

  sendReminderValues(esign) {
    this.selectedSignerId = esign.signatory_id;
    this.queryParams['order_id'] = this.orderId;
    this.queryParams['signatory_id'] = this.selectedSignerId;
    this.eSignService.sendSignerReminder(this.queryParams).subscribe((res) => {
      this.messageService.add({
        severity: 'success',
        summary: res.message,
        icon: 'pi-check-circle',
      });
    });

    //}
  }

  onViewCertClick(selectedStamp, content) {
    this.selectedStampData = selectedStamp;
    this.modalService
      .open(content, {
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
      })
      .result.then(
        (result) => {},
        (reason) => {},
      );
  }

  approveOrder() {
    const data = {
      order_id: this.orderId,
      reviewer_email: this.loggedEmail,
      action: 'approve',
    };
    this.orderService.approveOrder(data).subscribe((res) => {
      this.getOrderDetail();
      this.messageService.add({
        severity: 'success',
        detail: `Order with  Id ${this.orderId} is Approved`,
      });
      this.closeModel();
    });
  }

  rejectOrder() {
    const data = {
      order_id: this.orderId,
      reviewer_email: this.loggedEmail,
      action: 'reject',
    };
    this.orderService.approveOrder(data).subscribe((res) => {
      this.getOrderDetail();
      this.messageService.add({
        severity: 'success',
        detail: `Order with  Id ${this.orderId} is Rejected`,
      });
      this.closeModel();
    });
  }

  //----------------------------------ReOpen Order ------------------------------------------//

  reOpenOrder(id) {
    const data = {
      order_id: this.orderId,
      reviewer_email: this.loggedEmail,
      action: 'reset',
    };
    this.orderService.approveOrder(data).subscribe((resp) => {
      if (resp.status == 200) {
        this.messageService.add({ severity: 'success', detail: resp.message });
        this.getOrderDetail();
      }
    });
  }

  //--------------------------------------------Digio Sign --------------------------------------//

  sendLinkToPayee(orderId) {
    this.orderService.sendLinkToPayee(orderId).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Payment Link',
          detail: 'Link Sent Successfully to ' + res.content.recipient_email,
        });
      } else {
        this.messageService.add({
          severity: 'error',
          detail: res.message,
        });
      }
    });
  }
  paymentOrderDataChange(event) {
    if (event.status === 200) {
      this.messageService.add({
        severity: 'success',
        summary: 'Order Placed successfully!',
        detail: event.message,
      });
      this.closeModel();
    }
  }
  getTotalStampValue() {
    const sum = this.stampDetails
      .map((item) => item.amount)
      .reduce((prev, curr) => prev + curr, 0);
    return sum;
  }
  getTotalEsignValue() {
    const sum = this.signDetails
      .map((item) => item.amount)
      .reduce((prev, curr) => prev + curr, 0);
    return sum;
  }
  /** Flattens the DSC / ELECTRONIC / AADHAAR signer buckets into the e-sign bill grid's rows, skipping
   *  any method with no signers. Order is fixed (DSC, ELECTRONIC, AADHAAR) to match the serial numbers
   *  assigned in getOrderDetails() and the row order the grid had before it used <app-data-table>.
   *
   *  This is materialised into a field rather than exposed as a getter because the grid is OnPush: a
   *  getter would hand it a brand-new array reference on every change-detection pass and re-render
   *  constantly. The trade-off is that it has to be rebuilt whenever an input changes, and the signer
   *  buckets and the per-method prices arrive from two independent async calls, so it's invoked from both
   *  and simply produces whatever is known at the time. */
  private buildEsignBillRows(): void {
    const methods = [
      { serial: this.dscSerialNo, method: 'DSC', price: this.dscPrice, signers: this.dscSigner },
      {
        serial: this.electronicSerialNo,
        method: 'ELECTRONIC',
        price: this.electronicPrice,
        signers: this.electronicSigner,
      },
      {
        serial: this.addharSerialNo,
        method: 'AADHAAR',
        price: this.aadhaarPrice,
        signers: this.aadhaarSigner,
      },
    ];

    this.esignBillRows = methods
      .filter((m) => m.signers?.length)
      .map((m) => ({
        serial: m.serial,
        method: m.method,
        price: m.price,
        qty: m.signers.length,
        amount: this.getTotalAmountEsignValue(m.price, m.signers.length),
      }));
  }

  getTotalAmountEsignValue(price, quantity) {
    let sum = price * quantity;
    return sum;
  }

  maskEmail(email: string): string {
    if (!email) return '';
    const atIndex = email.indexOf('@');
    if (atIndex < 0) return email;
    const local = email.slice(0, atIndex);
    const domain = email.slice(atIndex);
    const visible = local.slice(0, 2);
    return visible + '****' + domain;
  }

  maskMobile(contact: string): string {
    if (!contact) return '';
    const str = String(contact);
    if (str.length >= 6) {
      return str.slice(0, 2) + '****' + str.slice(-2);
    }
    return str;
  }


  payBillNow() {
    this.paymentLink = this.paymentData.payment_url;
    this.popupWindow = window.open(this.paymentLink, '_blank');
    this.storageService.setPaymentStatus('payment_started');
    this.startPaymentInterval();

    const checkWindowInterval = setInterval(() => {
      if (this.popupWindow && this.popupWindow.closed) {
        this.onPopupClosed();
        clearInterval(checkWindowInterval);
      }
    }, 1000);
  }

  onPopupClosed() {
    this.modalService.dismissAll();
  }

  private normalizeNeslSignerStatus(status: unknown): string {
    return String(status || '')
      .trim()
      .toUpperCase()
      .replace(/^ESIGN\s+/, '');
  }

  private getNeslSigners(): any[] {
    return (this.signerDetails?.length ? this.signerDetails : this.esigns) || [];
  }

  isPrimaryNeslSigner(esign: any): boolean {
    if (!this.isOperationalNeslOrder || !esign) return false;
    const signers = [...this.getNeslSigners()].sort(
      (left, right) =>
        Number(left?.signatory_sequence || 0) -
        Number(right?.signatory_sequence || 0),
    );
    const first = signers[0];
    return Boolean(
      first &&
        (first.signatory_id === esign.signatory_id ||
          Number(first.signatory_sequence) === Number(esign.signatory_sequence)),
    );
  }

  isPrimaryPendingNeslSigner(esign: any): boolean {
    if (!this.isOperationalNeslOrder || !esign) return false;
    const pending = this.getNeslSigners()
      .filter(
        (signer) =>
          this.normalizeNeslSignerStatus(signer?.status) === 'REQUESTED',
      )
      .sort(
        (left, right) =>
          Number(left?.signatory_sequence || 0) -
          Number(right?.signatory_sequence || 0),
      )[0];
    return Boolean(
      pending &&
        (pending.signatory_id === esign.signatory_id ||
          Number(pending.signatory_sequence) ===
            Number(esign.signatory_sequence)),
    );
  }

  canShowSendSignLink(esign: any): boolean {
    if (this.isOperationalNeslOrder) {
      return this.canUseNeslLinkActions && this.isPrimaryPendingNeslSigner(esign);
    }
    return Boolean(
      esign?.sign_url &&
        this.order?.status === 'IN_PROGRESS' &&
        esign?.status === 'REQUESTED' &&
        esign?.sign_method !== 'CLOUD_SIGN',
    );
  }

  canShowCopySignLink(esign: any): boolean {
    return this.canShowSendSignLink(esign);
  }

  sendSignLink(esign: any): void {
    if (this.isOperationalNeslOrder) {
      this.retriggerNeslEsignLink();
      return;
    }
    this.sendContractReminderValues(esign);
  }

  copySignerLink(esign: any, index: number): void {
    if (this.isOperationalNeslOrder) {
      this.getNeslEsignLink(index);
      return;
    }
    if (this.showCopyLink) {
      this.getLink(esign.signatory_id, esign.sign_method, index);
    } else {
      this.copyLink(esign.sign_url, index);
    }
  }

  navigateToRetrigger() {
    if (!this.canOpenNeslRetrigger) {
      return;
    }
    const filteredSigners = this.getNeslSigners().filter(
      (signer) =>
        this.normalizeNeslSignerStatus(signer?.status) === 'NOT AFFIXED',
    );
    const retriggerTransferState = {
      signerDetails: filteredSigners,
      orderDetail: this.orderDetail,
    };

    this.pathRoute.navigate(['/doqfy/edit-esign'], {
      state: { retriggerTransferState },
    });

    this.modalService.dismissAll();
  }
  startPaymentInterval() {
    this.modalService
      .open(this.paymentPopup, {
        // Use this.reviewOrder directly
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        },
      );
    this.paymentStatus = setInterval(() => {
      let paymentState = this.storageService.getPaymentStatus() || null;
      if (paymentState === 'payment_started') {
      } else if (paymentState === 'payment_successfull') {
        localStorage.removeItem('paymentStatus');

        this.closeModel();
      } else if (paymentState === 'payment_failed') {
        localStorage.removeItem('paymentStatus');

        this.closeModel();
      }
    }, 2000); //
  }

  get canOpenNeslRetrigger(): boolean {
    const signerStatuses = this.getNeslSigners().map((signer) =>
      this.normalizeNeslSignerStatus(signer?.status),
    );
    return (
      this.isOperationalNeslOrder &&
      this.orderDetail?.[0]?.additional_details?.edit_mode === true &&
      signerStatuses.length > 0 &&
      signerStatuses.every((status) =>
        ['COMPLETED', 'NOT AFFIXED'].includes(status),
      ) &&
      signerStatuses.some((status) => status === 'NOT AFFIXED')
    );
  }

  get canUseNeslLinkActions(): boolean {
    const terminalOrderStatuses = ['COMPLETED', 'CANCELLED', 'REJECTED'];
    const hasRequestedSignatory = this.getNeslSigners().some(
      (esign) =>
        this.normalizeNeslSignerStatus(esign?.status) === 'REQUESTED',
    );
    return (
      this.isOperationalNeslOrder &&
      !terminalOrderStatuses.includes(String(this.order?.status ?? '').toUpperCase()) &&
      hasRequestedSignatory
    );
  }

  private getNeslTransactionId(): string {
    return String(this.order?.referance_id ?? '').trim();
  }

  private showNeslError(error: any, fallbackMessage: string): void {
    this.neslActionLoading = null;
    this.messageService.add({
      severity: 'error',
      detail:
        error?.error?.message ||
        error?.error?.content?.statusMessage ||
        error?.error?.content?.statusMsg ||
        fallbackMessage,
    });
  }

  private extractNeslLink(content: any): string {
    const directLink =
      content?.esignLink || content?.eSignLink || content?.esign_url || '';
    if (typeof directLink === 'string' && directLink.trim()) {
      return directLink.trim();
    }
    const documentStatuses = Array.isArray(content?.docStatus)
      ? content.docStatus
      : [];
    const statusWithLink = documentStatuses.find(
      (item: any) => item?.esignLink || item?.eSignLink,
    );
    return String(
      statusWithLink?.esignLink || statusWithLink?.eSignLink || '',
    ).trim();
  }

  getNeslTransactionStatus(): void {
    if (!this.isOperationalNeslOrder || this.neslActionLoading) return;
    const txnID = this.getNeslTransactionId();
    if (!txnID) return;

    this.neslActionLoading = 'status';
    this.eSignService.getNeslTransactionStatus(txnID).subscribe({
      next: (response) => {
        this.neslActionLoading = null;
        const documentStatuses = Array.isArray(response.content?.docStatus)
          ? response.content.docStatus
          : [];
        const signerStatuses = documentStatuses
          .map(
            (item) =>
              `${item.signtryName || `Signer ${item.seqNo || ''}`}: ${
                item.esignStatus || 'Pending'
              }`,
          )
          .join(', ');
        this.neslStatusMessage =
          signerStatuses ||
          response.content?.statusMsg ||
          response.content?.statusMessage ||
          response.message;
        this.messageService.add({
          severity: 'info',
          summary: 'NeSL transaction status',
          detail: this.neslStatusMessage,
        });
      },
      error: (error) =>
        this.showNeslError(error, 'Unable to retrieve NeSL transaction status'),
    });
  }

  reconcileNeslOrder(): void {
    if (!this.isOperationalNeslOrder || this.neslActionLoading) return;
    const txnID = this.getNeslTransactionId();
    if (!txnID) return;

    this.neslActionLoading = 'sync';
    this.eSignService.reconcileNeslOrder(txnID).subscribe({
      next: (response) => {
        this.neslActionLoading = null;
        this.neslStatusMessage = response.message;
        this.messageService.add({
          severity: 'success',
          detail: response.message || 'NeSL order details synchronized',
        });
        this.getOrderDetail();
      },
      error: (error) =>
        this.showNeslError(error, 'Unable to synchronize NeSL order details'),
    });
  }

  getNeslEsignLink(index = 0): void {
    if (!this.canUseNeslLinkActions || this.neslActionLoading) return;
    const txnID = this.getNeslTransactionId();
    if (!txnID) return;

    this.neslActionLoading = 'link';
    this.eSignService
      .getOrRetriggerNeslLink(txnID, 'get_esign_link')
      .subscribe({
        next: (response) => {
          this.neslActionLoading = null;
          const esignLink = this.extractNeslLink(response.content);
          if (!esignLink) {
            this.messageService.add({
              severity: 'warn',
              detail: response.message || 'No pending NeSL eSign link found',
            });
            return;
          }
          this.copyLink(esignLink, index);
          this.getOrderDetail();
        },
        error: (error) =>
          this.showNeslError(error, 'Unable to retrieve the NeSL eSign link'),
      });
  }

  retriggerNeslEsignLink(): void {
    if (!this.canUseNeslLinkActions || this.neslActionLoading) return;
    const txnID = this.getNeslTransactionId();
    if (!txnID) return;

    this.neslActionLoading = 'retrigger';
    this.eSignService
      .getOrRetriggerNeslLink(txnID, 'retrigger_esign_link')
      .subscribe({
        next: (response) => {
          this.neslActionLoading = null;
          this.neslStatusMessage = response.message;
          this.messageService.add({
            severity: 'success',
            detail: response.message || 'NeSL eSign link retriggered',
          });
        },
        error: (error) =>
          this.showNeslError(error, 'Unable to retrigger the NeSL eSign link'),
      });
  }

  refreshOrder() {
    this.orderService.esignOrderApi(this.orderId).subscribe((res) => {
      this.getOrderDetail();
    });
  }

  // for cat upload esigns
  enableEdit(index: number) {
    const esign = this.esigns[index];
    esign.isEditing = true;
    esign.tempName = esign.name;
    esign.tempEmail = esign.email;
    esign.tempSignMode = esign.sign_mode;
    esign.tempAadhaarDigits = esign.aadhaar_digits || 'NA';
    esign.tempContactNumber = esign.contact_number || '';
  }

  saveChanges(index: number) {
    const esign = this.esigns[index];

    if (!esign.tempName || !esign.tempName.trim()) {
      this.messageService.add({
        severity: 'error',
        detail: 'Please enter a valid signatory name',
      });
      return;
    }

    if (!esign.tempEmail || !this.isValidEmail(esign.tempEmail)) {
      this.messageService.add({
        severity: 'error',
        detail: 'Please enter a valid email address',
      });
      return;
    }

    esign.name = esign.tempName.trim();
    esign.email = esign.tempEmail.trim();
    esign.sign_mode = esign.tempSignMode.trim();
    esign.aadhaar_digits = esign.tempAadhaarDigits.trim();
    esign.contact_number = esign.tempContactNumber.trim();
    esign.isEditing = false;

    delete esign.tempName;
    delete esign.tempEmail;
    delete esign.tempContactNumber;
    delete esign.tempSignMode;
    delete esign.tempAadhaarDigits;

    this.updateEsignDetails(esign, index);
  }

  cancelEdit(index: number) {
    const esign = this.esigns[index];
    esign.isEditing = false;

    delete esign.tempName;
    delete esign.tempEmail;
    delete esign.tempContactNumber;
    delete esign.tempSignMode;
    delete esign.tempAadhaarDigits;
  }
  // For signerDetails array (esign only)
  enableEditSigner(index: number) {
    const esign = this.signerDetails[index];
    // if (esign.status === 'FAILED' && !esign.provider_details.retry) {
    //   this.messageService.add({
    //     severity: 'error',
    //     detail: 'Maximum limit reached for edit party name',
    //   });
    //   return;
    // }
    esign.isEditing = true;
    esign.tempName = esign.name;
    esign.tempEmail = esign.email;
    esign.tempSignMode = esign.sign_mode;
    esign.tempContactNumber = esign.contact_number || '';
    esign.tempAadhaarDigits = esign.aadhaar_digits;
  }

  saveSignerChanges(index: number) {
    const esign = this.signerDetails[index];

    // Validate Party Name (Mandatory, Alpha characters only, not blank)
    if (!esign.tempName || !esign.tempName.trim()) {
      this.messageService.add({
        severity: 'error',
        detail: 'Party name is required and cannot be blank',
      });
      return;
    }

    const namePattern = /^[a-zA-Z\s]+$/;
    if (!namePattern.test(esign.tempName.trim())) {
      this.messageService.add({
        severity: 'error',
        detail: 'Party name must contain only alphabetic characters',
      });
      return;
    }

    // Validate Party Email (Optional, but if provided must be valid format)
    if (esign.tempEmail && esign.tempEmail.trim()) {
      if (!this.isValidEmail(esign.tempEmail.trim())) {
        this.messageService.add({
          severity: 'error',
          detail: 'Please enter a valid email address',
        });
        return;
      }
    }

    // Enhanced Mobile validation
    if (esign.tempContactNumber && esign.tempContactNumber.trim()) {
      const cleanedMobile = esign.tempContactNumber.trim().replace(/\D/g, '');

      if (cleanedMobile.length !== 10) {
        this.messageService.add({
          severity: 'error',
          detail: 'Mobile number must be exactly 10 digits',
        });
        return;
      }
      if (!cleanedMobile.match(/^[6-9]\d{9}$/)) {
        this.messageService.add({
          severity: 'error',
          detail:
            'Please enter a valid Indian mobile number (should start with 6, 7, 8, or 9)',
        });
        return;
      }

      esign.tempContactNumber = cleanedMobile;
    }

    // If all validations pass, save the changes
    esign.name = esign.tempName.trim();
    esign.email = esign.tempEmail ? esign.tempEmail.trim() : '';
    esign.sign_mode = esign.tempSignMode ? esign.tempSignMode.trim() : '';
    esign.aadhaar_digits = esign.tempAadhaarDigits
      ? esign.tempAadhaarDigits.trim()
      : '';
    esign.contact_number = esign.tempContactNumber
      ? esign.tempContactNumber.trim()
      : '';
    esign.isEditing = false;

    delete esign.tempName;
    delete esign.tempEmail;
    delete esign.tempContactNumber;
    delete esign.tempSignMode;
    delete esign.tempAadhaarDigits;

    this.updateEsignDetails(esign, index);
  }

  // Helper method for email validation (if not already present)
  isValidEmail(email: string): boolean {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  onNameKeyPress(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    const char = String.fromCharCode(charCode);
    const pattern = /^[a-zA-Z\s]$/;

    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  // Handle input event to clean any pasted non-alphabetic content
  onNameInput(event: any, index: number) {
    let value = event.target.value;

    value = value.replace(/[^a-zA-Z\s]/g, '');

    value = value.replace(/\s+/g, ' ');

    this.signerDetails[index].tempName = value;
  }

  cancelSignerEdit(index: number) {
    const esign = this.signerDetails[index];
    esign.isEditing = false;

    delete esign.tempName;
    delete esign.tempEmail;
    delete esign.tempContactNumber;
    delete esign.tempSignMode;
    delete esign.tempAadhaarDigits;
  }

  onMobileKeyPress(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow only numeric characters (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  // Handle input event to enforce 10-digit limit
  onMobileInput(event: any, index: number) {
    let value = event.target.value;

    value = value.replace(/\D/g, '');

    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    this.signerDetails[index].tempContactNumber = value;
  }

  allowOnlyDigits(event: KeyboardEvent): void {
    const charCode = event.which || event.keyCode;

    // Allow only digits (0–9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  private updateEsignDetails(esign: any, index: number) {
    const updatedEsgin = [
      {
        signatory_id: esign.signatory_id,
        esign_sequence: esign.esign_sequence_id,
        signatory_name: esign.name,
        signatory_email: esign.email,
        signatory_mobile_number: esign.contact_number,
        provider: esign.sign_provider,
        methods: esign.sign_method,
        sign_mode: esign.sign_mode,
        sign_cancel: false,
        aadhaar_digits: esign.aadhaar_digits,
        account_id: this.storageService.getAccountId(),
      },
    ];

    this.eSignService.updateEsignDetails(updatedEsgin).subscribe({
      next: (response: any) => {
        this.messageService.add({
          severity: 'success',
          detail: response.message,
        });
        this.closeModel();
      },
      error: (error: any) => {
        this.closeModel();
      },
    });
  }

  deleteSign(index: number) {
    const esign = this.esigns[index];
    this.deleteEsignDetails(esign, index);
  }

  deleteSigner(index: number) {
    const esign = this.signerDetails[index];
    this.deleteEsignDetails(esign, index);
  }

  private deleteEsignDetails(esign: any, index: number) {
    const signatoryDetails = [
      {
        signatory_id: esign.signatory_id,
        esign_sequence: esign.esign_sequence_id,
        signatory_name: esign.name,
        signatory_email: esign.email,
        signatory_mobile_number: esign.contact_number,
        provider: esign.sign_provider,
        methods: esign.sign_method,
        sign_cancel: true,
        aadhaar_digits: esign.aadhaar_digits,
        account_id: this.storageService.getAccountId(),
      },
    ];

    this.eSignService.updateEsignDetails(signatoryDetails).subscribe({
      next: (response: any) => {
        this.messageService.add({
          severity: 'success',
          detail: response.message,
        });
        this.closeModel();
      },
      error: (error: any) => {
        this.closeModel();
      },
    });
  }

  copyToClipboard(text: string) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.justCopied = true;

        setTimeout(() => {
          this.justCopied = false;
        }, 1500);
      })
      .catch((err) => {
        this.justCopied = false;
        console.error('Could not copy text: ', err);
      });
  }

  getBulkStatusLabel(status: string): string {
    const map: Record<string, string> = {
      PENDING: 'Pending',
      AWAITING_APPROVAL: 'Awaiting Approval',
      COMPLETED: 'Completed',
      FAILED: 'Failed',
      IN_PROGRESS: 'In Progress',
      CANCELLED: 'Cancelled',
    };
    return map[status] ?? status;
  }

  approveBulkOrder(): void {
    this.orderService
      .approveBulkCatUploadOrder(this.bulkOrderData?.bulk_order_uuid)
      .subscribe(
        (res) => {
          this.messageService.add({
            severity: 'success',
            detail: 'Bulk order approved successfully',
          });
          this.closeModel();
        },
        () => {
          this.messageService.add({
            severity: 'error',
            detail: 'Failed to approve. Please try again.',
          });
        },
      );
  }

  rejectBulkOrder(): void {
    this.rejectionReason = '';
    this.rejectionSubmitted = false;

    this.modalService.open(this.rejectReasonModal, {
      size: 'md',
      ariaLabelledBy: 'reject-modal-title',
      backdrop: 'static', 
      keyboard: false,
      centered: true
    });
  }
  confirmRejectBulkOrder(): void {
    this.rejectionSubmitted = true;

    // Guard: don't proceed without a reason
    if (!this.rejectionReason?.trim()) {
      return;
    }

    this.orderService
      .rejectBulkCatUploadOrder(this.bulkOrderData?.bulk_order_uuid, this.rejectionReason.trim())
      .subscribe(
        () => {
          this.messageService.add({
            severity: 'success',
            detail: 'Bulk order rejected successfully'
          });
          this.modalService.dismissAll();
          this.rejectionReason = '';
          this.rejectionSubmitted = false;
          this.closeModel(); // closes parent modal too
        },
        () => {
          this.messageService.add({
            severity: 'error',
            detail: 'Failed to reject. Please try again.'
          });
        }
    );
  }
  
  viewFilePdf(referenceId: string, content: TemplateRef<any>): void {
  const uuid = this.bulkOrderData?.bulk_order_uuid;  
  if (!uuid) {
    this.messageService.add({
      severity: 'error',
      detail: 'Bulk Order UUID not found.',
    });
    return;
  }

  if (!referenceId || referenceId === 'undefined' || referenceId === 'null') {
    this.messageService.add({
      severity: 'error',
      detail: 'Reference ID not found. Please check the data.',
    });
    return;
  }
  const refId = String(referenceId);
  this.orderService.getBulkOrderFileBase64(uuid, refId).subscribe({
    next: (response) => {
      try {
        let base64Data = response.base64_data || response.content || response.data || response;                
        if (!base64Data) {
          throw new Error('No base64 data in response');
        }
        
        if (typeof base64Data === 'string' && base64Data.includes('base64,')) {
          base64Data = base64Data.split('base64,')[1];
        }

        const byteArray = new Uint8Array(
          atob(base64Data)
            .split('')
            .map((char) => char.charCodeAt(0))
        );

        const pdfSignature = String.fromCharCode(...byteArray.slice(0, 5));
        if (pdfSignature !== '%PDF-') {
          throw new Error('Invalid PDF format');
        }

        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(url);

        this.modalService.open(content, {
          size: 'lg',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static',
          keyboard: false,
        });
      } catch (e) {
        console.error('PDF parsing error:', e);
        this.messageService.add({
          severity: 'error',
          detail: 'Failed to load document preview. Error: ' + e.message,
        });
      }
    },
    error: (error) => {
      console.error('API error:', error);
      this.messageService.add({
        severity: 'error',
        detail: error?.error?.message || 'Failed to fetch document. Please try again.',
      });
    }
  });
}
  openPaymentSummary() {
    const idToUse = this.orderId || (this.order && this.order.id) || (this.order && this.order.order_id);

    if (!idToUse) {
      console.error("Order ID is missing. Cannot open summary.");
      return;
    }

    this.paymentAmountData = null; 

    const modalRef = this.modalService.open(this.paymentSummaryModal, {
      centered: true,
      size: 'md'
    });

    this.orderService.getPaymentAmountDetails(idToUse, false).subscribe(
      (res) => {
        this.paymentAmountData = res['content'];
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error fetching payment details:', error);
        modalRef.close();
        this.cdr.detectChanges();
      }
    );
  }

  downloadBulkExcel(): void {
    const uuid = this.bulkOrderData?.bulk_order_uuid;
    if (!uuid) {
      this.messageService.add({
        severity: 'error',
        detail: 'Bulk Order UUID not found.',
      });
      return;
    }

    this.orderService.downloadBulkOrderExcel(uuid).subscribe({
      next: (blob: Blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `bulk_order_${uuid}.xlsx`;
        link.click();
        URL.revokeObjectURL(url);
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          detail: 'Failed to download Excel. Please try again.',
        });
      },
    });
  }
}